module.exports = __webpack_public_path__ + "static/media/tescoForOne.6d3260ed.csv";